import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app-routing.module';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideConnectAngular } from '@quickweb/connect-angular';
import {
  getOpenIdRootProviders,
  ResponseType,
} from '@quickweb/authenticator-angular';
import { environment } from 'src/environments/environment';
import { DatadogService } from './shared/services/data-dog.service';

export function initFactory(svc: DatadogService) {
  return () => svc.init(); // may return Promise/Observable/void
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,

      useFactory: initFactory,
      deps: [DatadogService],
      multi: true,
    },

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideConnectAngular(),
    ...getOpenIdRootProviders({
      providerConfig: {
        issuer: environment.openId.issuerUrl,
        clientId: environment.appClientId,
        redirectUri: environment.openId.callbackUrl,

        //postLogoutRedirectUri: environment.openId.callbackUrl,
        historyCleanupOff: false,
        protectedResourceMap: new Map([
          [
            environment.charon.entrypoint,
            [
              'agent-iframe.read',
              'openid profile email offline_access api://0a850198-bee6-4a07-b90c-d8f73aee190b/PS7-agent-iframe',
              'api://0a850198-bee6-4a07-b90c-d8f73aee190b/PS7-agent-iframe',
            ],
          ],
        ]),
        customHeaders: [
          { key: 'x-itau-apikey', value: environment.appClientId },
        ],
        logLevel: 1,
        scope: environment.openId.scope,
        autoUserInfo: false,
        responseType: ResponseType.CODE,
        useRefreshToken: true,
        silentRenew: false,
        disableRefreshIdTokenAuthTimeValidation: false,
        maxIdTokenIatOffsetAllowedInSeconds: 180,
        disableIatOffsetValidation: true,
        ignoreNonceAfterRefresh: true,
        triggerRefreshWhenIdTokenExpired: true,
        //postLoginRoute: window.location.pathname,
        //unauthorizedRoute: window.location.pathname,
      },
    }),
  ],
};
